import '../css/animations.css';
import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import JoditVue from 'jodit-vue';
import 'jodit/es2021/jodit.min.css';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import posthog from 'posthog-js';
import { createApp, DefineComponent, h } from 'vue';
import { ZiggyVue } from 'ziggy-js';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Config comes from the server
let posthogEnabled = false;

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob<DefineComponent>('./Pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        // Anonymous device-only tracking (single shared login): we never identify(),
        // so PostHog distinguishes individuals by its per-browser anonymous distinct_id.
        const config = props.initialPage.props.posthog;
        if (config?.key) {
            posthog.init(config.key, {
                api_host: config.host || 'https://us.i.posthog.com',
                defaults: '2026-05-30',
                disable_session_recording: false,
            });
            posthogEnabled = true;
        }

        const app = createApp({ render: () => h(App, props) });
        app.config.errorHandler = (err, instance, info) => {
            if (posthogEnabled) {
                posthog.captureException(err, { info });
            }
            console.error(err);
        };
        app.use(plugin).use(ZiggyVue).use(JoditVue).mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
